import React from 'react'
import { generalStrings } from 'src/common/generalStrings'
import { Button } from 'src/components/Button'
import { PaginatedTable } from 'src/components/PaginatedTable'
import { useDrawer } from 'src/hooks/useDrawer'
import { areFiltersOn } from 'src/pages/Learn/types'
import { useLazyGetAdminsQuery } from 'src/store/APIs/admins'
import { useMeQuery } from 'src/store/APIs/misc'
import { UserType } from 'src/store/APIs/types'

import styles from '../webPortalUsers.module.scss'
import { AdminDrawer } from './AdminDrawer'
import { useAdminsColumns } from './columns'
import { strings } from './strings'

interface AdminsProps {}

export const Admins: React.FC<AdminsProps> = () => {
  const { open, onCloseDrawer, selectedId, showDrawer, openView } = useDrawer()

  const { resetFilters, ...columnsAndFilters } = useAdminsColumns(openView)

  const { data } = useMeQuery()

  const filtersOn = areFiltersOn(columnsAndFilters.filteredInfo.filters)

  return (
    <>
      <AdminDrawer
        open={open}
        onCloseDrawer={onCloseDrawer}
        selectedId={selectedId}
      />
      <div className={styles.container}>
        <div className={styles.buttonContainer}>
          <Button
            className={styles.buttonStyle}
            onClick={resetFilters}
            disabled={!filtersOn}>
            {generalStrings.clearFiltersButtonLabel}
          </Button>
          {data?.user.user_type === UserType.admin && (
            <Button
              type="primary"
              className={styles.buttonStyle}
              onClick={showDrawer}>
              {strings.addAdminButtonLabel}
            </Button>
          )}
        </div>
        <PaginatedTable
          className={styles.table}
          useLazyQuery={useLazyGetAdminsQuery}
          {...columnsAndFilters}
        />
      </div>
    </>
  )
}
